module.exports = __webpack_public_path__ + "static/media/full-locked.ac8762a3.png";